(function () {
  'use strict';

  var FORM_SELECTOR = 'form.product-single__form, form[action*="/cart/add"]';

  function resolveScope(widget) {
    var el = widget;
    while (el && el !== document.body) {
      if (el.querySelector && el.querySelector(FORM_SELECTOR)) return el;
      el = el.parentElement;
    }
    return document;
  }

  function setQuantity(scope, qty) {
    var forms = scope.querySelectorAll(FORM_SELECTOR);
    if (!forms.length && scope !== document) {
      forms = document.querySelectorAll(FORM_SELECTOR);
    }
    Array.prototype.forEach.call(forms, function (form) {
      var input = form.querySelector('input[name="quantity"], select[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        input.setAttribute('data-mb-quantity', '');
        form.appendChild(input);
      }
      if (String(input.value) !== String(qty)) {
        input.value = qty;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function selectCard(widget, radio) {
    var cards = widget.querySelectorAll('[data-mb-card]');
    Array.prototype.forEach.call(cards, function (card) {
      var input = card.querySelector('.mb-offer__radio');
      card.classList.toggle('is-selected', input === radio);
    });
  }

  function readPriceMap(widget) {
    var node = widget.querySelector('script[data-mb-prices]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function renderVariant(widget, variantId) {
    var map = widget.mbPrices;
    if (!map || !variantId) return;

    var rows = map[String(variantId)];
    if (!rows) return;

    var cards = widget.querySelectorAll('[data-mb-card]');
    Array.prototype.forEach.call(cards, function (card) {
      var index = parseInt(card.getAttribute('data-mb-tier'), 10);
      var row = rows[isNaN(index) ? 0 : index];
      if (!row) return;

      var priceEl = card.querySelector('[data-mb-price]');
      var compareEl = card.querySelector('[data-mb-compare]');
      var saveEl = card.querySelector('[data-mb-save]');
      var radio = card.querySelector('.mb-offer__radio');

      if (priceEl) priceEl.textContent = row.p || '';

      if (compareEl) {
        if (row.c) {
          compareEl.textContent = row.c;
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }

      if (saveEl) {
        if (row.s) {
          saveEl.textContent = row.s;
          saveEl.hidden = false;
        } else {
          saveEl.textContent = '';
          saveEl.hidden = true;
        }
      }

      if (radio && priceEl) {
        var label = card.querySelector('.mb-offer__label');
        var labelText = label ? label.textContent.trim() : radio.value;
        radio.setAttribute('aria-label', labelText + ', ' + (row.p || ''));
      }
    });
  }

  function currentVariantId(widget) {
    var scope = resolveScope(widget);
    var master = (scope === document ? document : scope).querySelector(
      'select[name="id"], input[name="id"]'
    );
    return master ? master.value : null;
  }

  function init(widget) {
    if (!widget || widget.dataset.mbInit === 'true') return;
    widget.dataset.mbInit = 'true';

    widget.mbPrices = readPriceMap(widget);

    var scope = resolveScope(widget);
    var checked =
      widget.querySelector('.mb-offer__radio:checked') ||
      widget.querySelector('.mb-offer__radio');

    if (checked) {
      selectCard(widget, checked);
      setQuantity(scope, checked.getAttribute('data-mb-qty') || checked.value || 1);
    }

    renderVariant(widget, currentVariantId(widget));

    widget.addEventListener('change', function (e) {
      var radio = e.target.closest('.mb-offer__radio');
      if (!radio) return;
      selectCard(widget, radio);
      setQuantity(scope, radio.getAttribute('data-mb-qty') || radio.value || 1);
    });

    var onVariantChange = function (event) {
      var variant = event && event.detail && event.detail.variant;
      if (!variant || !variant.id) return;
      renderVariant(widget, variant.id);
    };

    document.addEventListener('variant:change', onVariantChange);
    document.addEventListener('variantPriceChange', onVariantChange);
    widget.mbOnVariantChange = onVariantChange;
  }

  function initAll() {
    var widgets = document.querySelectorAll('[data-mb-offer]');
    Array.prototype.forEach.call(widgets, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();